import JSZip from 'jszip';

export const parseZipFile = async (file: File) => {
  const zip = new JSZip();
  const zipResult = await zip.loadAsync(file);
  return zipResult;
};
